import { Vector2 } from '@technology/web3d';

export const WEBMERCATOR_PROJECTION =
  '+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs';

export const defaultMercatorProjection = {
  epsg: 'EPSG:3857',
  proj4def: WEBMERCATOR_PROJECTION,
  bounds: [
    // eslint-disable-next-line no-magic-numbers
    new Vector2(-20037508.342789244, -20037508.342789244),
    // eslint-disable-next-line no-magic-numbers
    new Vector2(20037508.342789244, 20037508.342789244),
  ] as [Vector2, Vector2],
  loadLimitBounds: [
    // eslint-disable-next-line no-magic-numbers
    new Vector2(-20037508.342789244, -20037508.342789244),
    // eslint-disable-next-line no-magic-numbers
    new Vector2(20037508.342789244, 20037508.342789244),
  ] as [Vector2, Vector2],
};
